export const useServicePowerMappings = () => {
    return (errorCodeString: string | undefined) => {
        const servicePowerMappings = {
            NoCoverage: "There is no Stark engineer coverage for this site between the Job Start and End Dates requests",
            MissingPostCode: "The Postcode of the Site the Appointment is not set up in the Stark Scheduling Solution",
            Default: "There was an error with this request, please try again"
        }
        switch(errorCodeString) {
            case "8":
                return servicePowerMappings.NoCoverage
            case "75":
                return servicePowerMappings.NoCoverage
            case "156":
                return servicePowerMappings.NoCoverage
            case "179":
                return servicePowerMappings.MissingPostCode
            default:
                return servicePowerMappings.Default
        }
    }
}
